import { environment } from "src/environments/environment";

export function setCookie(cname: string, cvalue: string, exdays: number) {
    const maxAge = exdays * 24 * 60 * 60; // sekúndur

    if (environment.env === "dev") {
        document.cookie = `${cname}=${cvalue}; Path=/; Max-Age=${maxAge}; SameSite=Lax`;
    } else {
        // Domain án leading dot, virkar fyrir mitt.e- og e-
        document.cookie =
            `${cname}=${cvalue};` +
            `Domain=e-fasteignir.is;` +
            `Path=/;` +
            `Max-Age=${maxAge};` +
            `Secure;` +
            `SameSite=Lax`;
    }
}

export function getCookie(cname: string) {
    const name = cname + "=";
    const ca = document.cookie.split(";");
    for (let i = 0; i < ca.length; i++) {
        let c = ca[i].trim();
        if (c.indexOf(name) === 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
}
